module.exports = __webpack_public_path__ + "static/media/maisnan.a1b01df.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/maisnan.mp3
// module id = 23
// module chunks = 0